var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcComplete = function SvgIcComplete(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 9.998,
    viewBox: "0 0 10 9.998",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_15",
    "data-name": "Subtraction 15",
    d: "M-10737,3015a5.007,5.007,0,0,1-5-5,5.007,5.007,0,0,1,5-5,5,5,0,0,1,5,5A5,5,0,0,1-10737,3015Zm-2.474-5.781h0l-.874.874,2.624,2.618,4.067-4.073-.872-.872-3.2,3.2-1.75-1.746Z",
    transform: "translate(10742.002 -3005)",
    fill: "#3a8814"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcComplete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_complete.763111879bbb0da1d4adca631f79d501.svg";